import React from 'react';

import {
  type UseAlarmsFindingsParams,
  useAlarmsFindings,
} from '../../hooks/useAlarmsFindings';

import { AlarmsFindingsCard } from './AlarmsFindingsCard';

export const AlarmsFindingsCardContainer: React.FC<
  UseAlarmsFindingsParams & { href?: string; className?: string }
> = ({ href, className, ...params }) => {
  const {
    activeCount,
    findingsCount,
    bySeverity,
    notDiagnosed,
    isLoading,
    isError,
    isEmpty,
    retry,
  } = useAlarmsFindings(params);

  return (
    <AlarmsFindingsCard
      activeCount={activeCount}
      findingsCount={findingsCount}
      bySeverity={bySeverity}
      notDiagnosed={notDiagnosed}
      isLoading={isLoading}
      isError={isError}
      isEmpty={isEmpty}
      onRetry={retry}
      href={href}
      className={className}
    />
  );
};
